import React, { Component } from 'react';
import QuickStats from '../components/QuickStats';
import _ from 'lodash';
import Paper from 'material-ui/Paper';
import CustomerList from '../components/CustomerList';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import OrderList from '../components/OrderList';
import { setTitle } from '../actions/topbar.actions';
import * as dashboardActions from '../actions/dashboard.actions';
import { connect } from 'react-redux';
import { RANGES } from '../reducers/dashboard.reducer';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.handleRangeChange = this.handleRangeChange.bind(this);
  }

  componentWillMount() {
    this.props.setTitle('Dashboard');
  }

  componentDidMount() {
    this.props.getStats(this.props.range);
    this.props.getCustomers();
    this.props.getOrders('qHRUfQYBJST61o0xWOP8', { limit: 5, include: ['user'] });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.range !== this.props.range) this.props.getStats(this.props.range);
  }

  handleRangeChange(e, key, value) {
    this.props.setRange(value);
  }

  renderOtherStuff() {
    return (
      <div>
        <Paper
          style={{
            width: 250,
            margin: 20,
            flex: 1,
          }}
        >
          <CustomerList customers={this.props.customers} />
        </Paper>
        <Paper
          style={{
            flex: 1,
            margin: 20,
          }}
        >
          <OrderList orders={this.props.orders} />
        </Paper>
      </div>
    )
  }

  render() {
    return (
      <div className="Dashboard">
        <DropDownMenu value={this.props.range.value} onChange={this.handleRangeChange}>
          {_.map(RANGES, range => <MenuItem value={range.value} primaryText={range.text} />)}
        </DropDownMenu>
        <QuickStats stats={this.props.stats} />
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >

        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state.dashboard;
}

export default connect(mapStateToProps, { setTitle, ...dashboardActions })(Dashboard);



// WEBPACK FOOTER //
// ./src/pages/Dashboard.js